<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">学职生涯</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/studystatus' }"
        >学习状态</el-breadcrumb-item
      >
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="top">
          <div class="left">学习状态</div>
        </div>
        <div class="center">
          对于一个学生，学习状态的情况非常重要，接下来从学习风格、学习技能、学习拖延、社会适应、考试焦虑、厌学情绪等多个维度量化分析，来帮助你了解自己的学习状态情况，帮你总结出适合你自己的学习风格，找到适合自己的学习方法，不断地去探索自我。
        </div>
        <div class="btn">
          <div
            class="appraisal"
            @click="goTest(item.id)"
            v-for="(item, index) in list"
            :key="index"
          >
            <img :src="item.pic" alt="" />
          </div>
          <div class="appraisal">
            <img src="./images/brand_10.png" alt="" />
          </div>
          <div class="appraisal">
            <img src="./images/brand_11.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Getlista } from "@/api/home";
export default {
  name: "HXtudystatus",

  data() {
    return {
      list: "",
    };
  },

  async mounted() {
    const res = await Getlista(this.$route.query.menuId || "339907931545669");
    this.list = res.data||res.result;
  },

  methods: {
    goTest(ScaleId) {
      this.$router.push({ path: "/psychologyTesting", query: { ScaleId } });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  margin-top: 10px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-width: 1050px;
  min-height: 1050px;
  .content {
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    .top {
      margin-bottom: 8px;
      .left {
        font-size: 22px;
        color: #333;
      }
    }
    .center {
      font-size: 16px;
      color: #666;
      margin-bottom: 53px;
    }
    .btn {
      display: flex;
      justify-content: left;
      margin-left: 80px;
      flex-wrap: wrap;
      width: 100%;
      .appraisal {
        width: 609px;
        height: 170px;
        margin-right: 130px;
        margin-bottom: 40px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>